<template>
  <v-file-input
    data-test-id="fileInput"
    v-bind="$attrs"
    prepend-icon=""
    :prepend-inner-icon="icon"
    v-model.trim="model"
    class="file-input"
    color="primary"
    density="comfortable"
    variant="underlined"
  >
    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-file-input>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES

// PROPS & EMITS
defineProps({
  icon: { type: String, default: 'mdi-paperclip' }
})

// REACTIVE VARIABLES
const model = defineModel<any>()

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>

<style lang="scss" scoped>
.file-input * {
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
